import { useId, type ReactNode } from 'react'

import styles from './ui.module.css'

interface TextFieldProps {
  label: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  /** Пояснение под полем: зачем оно и что будет со значением. */
  hint?: string
  type?: 'text' | 'password' | 'email'
  autoComplete?: string
  onSubmit?: () => void
}

export function TextField({
  label,
  value,
  onChange,
  placeholder,
  hint,
  type = 'text',
  autoComplete,
  onSubmit
}: TextFieldProps): ReactNode {
  const id = useId()
  return (
    <div className={styles.field}>
      <label className={styles.fieldLabel} htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        className={styles.input}
        type={type}
        value={value}
        placeholder={placeholder}
        autoComplete={autoComplete}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && onSubmit !== undefined) {
            event.preventDefault()
            onSubmit()
          }
        }}
      />
      {hint !== undefined && <span className={styles.hint}>{hint}</span>}
    </div>
  )
}

/** Сегментированный переключатель: ячейки с общей рамкой. */
export function Segmented<T extends string>({
  options,
  value,
  onChange,
  ariaLabel
}: {
  options: { value: T; title: string }[]
  value: T
  onChange: (value: T) => void
  ariaLabel?: string
}): ReactNode {
  return (
    <div className={styles.segmented} role="tablist" aria-label={ariaLabel}>
      {options.map((option) => {
        const selected = option.value === value
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={selected}
            className={[
              styles.segment,
              selected ? styles.segmentSelected : ''
            ]
              .filter(Boolean)
              .join(' ')}
            onClick={() => onChange(option.value)}
          >
            {option.title}
          </button>
        )
      })}
    </div>
  )
}
